export function getDescription(treatment_fields, is_required) {
  return `${treatment_fields
    .map(treatment_field => treatment_field.name)
    .join(', ')}${is_required ? ' (mandatory)' : ''}`
}
